import { Stack } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { HomeFeature } from '../../app/stores/homeFeatureVisibilityStore';
import { useStore } from '../../app/stores/store';
import { HomeAutoRecommend } from './HomeAutoRecommend/HomeAutoRecommend';
import HomeFeatureVisibilityControl from './HomeFeatureVisibilityControl';
import { HomeTableEquipment } from './HomeTableEquipment/HomeTableEquipment';
import HomeTrend from './HomeTrend/HomeTrend';


function Home() {
    const { accountStore: { getUser }, commonStore, homeFeatureVisibilityStore } = useStore();
    const { visibleItem } = homeFeatureVisibilityStore

    useEffect(() => {
        getUser();
    }, [getUser]);

    useEffect(() => {
        commonStore.setTitlePage('Home Page');
    });

    const features = [
        {
            name: HomeFeature.TrendChart,
            element: HomeTrend
        },
        {
            name: HomeFeature.AutomationRecommendation,
            element: HomeAutoRecommend
        },
        {
            name: HomeFeature.TableEquipment,
            element: HomeTableEquipment
        }
    ]
    
    return (
        <Stack spacing={2}>
            <HomeFeatureVisibilityControl />
            <Stack direction="column" spacing={3} pb={3}>
                {features.map((i, x) => (
                    visibleItem.includes(i.name) && <i.element key={x} />
                ))}
            </Stack>
        </Stack>
    );
}

export default observer(Home);
